import { useQuery as useQueryOriginal } from '@apollo/client'
import gql from 'graphql-tag'
import { fetchPolicy as globalFetchPolicy } from 'config/graphql'
import { transformData } from '../utils'

const useQuery = (query, options) => {
	const noQuery = !query
	const { data, ...rest } = useQueryOriginal(noQuery ? gql`query{_}` : query, {
		skip: noQuery,
		fetchPolicy: globalFetchPolicy,
		errorPolicy: 'all',
		notifyOnNetworkStatusChange: true,
		...options
	})
	const { data: transformedData, ...dataInfo } = transformData(data)

	return noQuery ? {} : {
		...rest,
		...dataInfo,
		data: transformedData,
		hasData: !!Object.keys(transformedData).length
	}
}

export default useQuery
